import { cn } from '@talentmesh/ui/lib/utils';
import React from 'react';

const CandidatesTableContainer = ({
    children,
    className,
    ...props
}: React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>) => {
    return (
        <div
            {...props}
            className={cn(
                'border-border flex flex-1 flex-col overflow-auto border-b',
                // select card (container) in shadcn react table
                '[&>.bg-card]:border-none',
                className,
            )}
        >
            {children}
        </div>
    );
};

export default CandidatesTableContainer;
